import { Directive, ElementRef, Input, OnInit, inject } from '@angular/core';
import { UserGroupService } from '../service/user-group.service';

@Directive({
  selector: '[userRoles]',
  standalone: true
})
export class UserRoleDirective implements OnInit {
  private el = inject(ElementRef);
  private userGroupService = inject(UserGroupService);


  @Input() role: string[] | string | undefined;

  ngOnInit(): void {
    const userGroups = this.userGroupService.getUserGroups();
    if (this.role) {
        let allowed = false;
        if(typeof this.role === 'string') this.role = [this.role];
        this.role.forEach(r => {
          if (userGroups.some(group => group === r)) {
            allowed = true;
            return;
          }
        });
        
        if (!allowed) {
          this.el.nativeElement.style.display = 'none';
        }
    }
  }
}
